import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "cropper" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "file-upload-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-cloud-upload upload-icon" }, null, -1)
const _hoisted_5 = { class: "empty-upload-message-container" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { style: {"margin":"0px 5px"} }, " Drag and drop an image here or ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cropper = _resolveComponent("cropper")!
  const _component_base_upload = _resolveComponent("base-upload")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    visible: _ctx.isFormVisible,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isFormVisible) = $event)),
    "dismissable-mask": true,
    modal: true,
    closable: true,
    header: 'Upload user image',
    class: "c-upload-avatar-form"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_cropper, {
          ref: "cropperRef",
          class: "cropper",
          src: _ctx.uploadedImage,
          "stencil-component": _ctx.circleStencil,
          "stencil-props": _ctx.cropperProps,
          canvas: _ctx.canvasSize,
          onReady: _ctx.onImageLoaded
        }, null, 8, ["src", "stencil-component", "stencil-props", "canvas", "onReady"])
      ]),
      (!_ctx.isImageLoaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_base_upload, {
              class: "image-uploader",
              name: "profilepicture",
              onUpload: _ctx.setAvatarImage
            }, {
              empty: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("span", _hoisted_5, [
                    _hoisted_6,
                    _createVNode(_component_base_upload, {
                      class: "image-upload-button",
                      mode: "basic",
                      onUpload: _ctx.setAvatarImage
                    }, null, 8, ["onUpload"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["onUpload"])
          ]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_base_button, {
          label: "Cancel",
          class: "transparent",
          onClick: _ctx.closeForm
        }, null, 8, ["onClick"]),
        _createVNode(_component_base_button, {
          label: "Save",
          icon: "pi pi-check",
          onClick: _ctx.setAvatar
        }, null, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}